module.exports = __webpack_public_path__ + "4657e2a5c3cb15136200b2641295e70c.svg";